import { useCallback, useContext, useEffect, useState } from "react";
import Loader from "../../components/Loader";
import { Link, useNavigate } from "react-router-dom";
import { Grid2 } from "@mui/material";
import StyledGridComp from "../../components/StyledGridComp";
import SearchedComponent from "../../components/SearchedComponent";
import { fetchAllLabelGroupDataService } from "../../services/labelGroupManagementService";
import { notifyError } from "../../utilities/helper";
import { MenuContext } from "../../App";
import useDebounceSearch from "../../hooks/useDebounceSearch";

const LabelGroupManagement = () => {
  const [load, setLoad] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [rowData, setRowData] = useState([]);
  const [rowLength, setRowLength] = useState(0);
  const [searchedValue, setSearchedValue] = useState("");
  const [addLabelGroup, setAddLabelGroup] = useState(false);

  const navigate = useNavigate();

  const { systemActions } = useContext(MenuContext);

  const access_token = localStorage?.getItem("access_token");
  const role = localStorage.getItem("role");

  const debounceQuery = useDebounceSearch(searchedValue, 500);

  useEffect(() => {
    if (page >= 0 && pageSize && access_token) {
      getAllLabelGroupData(pageSize, page, access_token, debounceQuery);
    }
  }, [page, pageSize, access_token, debounceQuery]);

  useEffect(() => {
    if (systemActions?.length > 0 && role !== "Admin") {
      let canAdd = false;
      const createFound = systemActions?.find(
        (item) => item?.name === "CanCreateLabelGroup"
      );
      if (createFound) {
        canAdd = true;
      }
      setAddLabelGroup(canAdd);
    } else if (role === "Admin") {
      setAddLabelGroup(true);
    }
  }, [systemActions]);

  const getAllLabelGroupData = async (
    pageSize,
    page,
    access_token,
    debouncedSearch = ""
  ) => {
    setLoad(true);
    try {
      const res = await fetchAllLabelGroupDataService(
        page + 1,
        pageSize,
        access_token,
        debouncedSearch
      );
      if (res?.status == 200) {
        setLoad(false);
        setRowData(res?.data?.result);
        setRowLength(res?.data?.totalCount);
      }
    } catch (err) {
      setLoad(false);
      notifyError(err?.mesage);
      console.log(err);
      if (err?.status == 401) {
        navigate("/unauthorize");
      }
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Name",
      width: 550,
      renderHeader: () => <div className="grid-heading">{"Name"}</div>,
      renderCell: (params) => {
        const name = params.row.name;
        const id = params.row.id;

        return (
          <>
            <button
              className="bread-crumbs-link grid-nav-btn"
              onClick={() => {
                navigate("/addUpdate-label-group-management", {
                  state: {
                    id: id,
                  },
                });
              }}
            >
              {name}
            </button>
          </>
        );
      },
    },
    {
      field: "countriesCommaSeperated",
      headerName: "Countries",
      width: 550,
      renderHeader: () => <div className="grid-heading">{"Countries"}</div>,
      renderCell: (params) => {
        let countriesCommaSeperated =
          params.row.countriesCommaSeperated.split(",");
        if (
          countriesCommaSeperated?.length == 1 &&
          countriesCommaSeperated[0] == ""
        ) {
          countriesCommaSeperated = [];
        }
        return (
          <>
            {countriesCommaSeperated?.length > 0 ? (
              <>
                {countriesCommaSeperated.map((item, index) => {
                  return (
                    <span
                      className="data-font"
                      key={index}
                      style={{
                        padding: "5px 8px",
                        background: "#E3E3E3",
                        borderRadius: "5px",
                        marginRight: "5px",
                      }}
                    >
                      {item}
                    </span>
                  );
                })}
              </>
            ) : (
              ""
            )}
          </>
        );
      },
    },
  ];

  const handleSearch = useCallback((e) => {
    setSearchedValue(e.target.value);
  }, []);

  return (
    <>
      <div className="content-body">
        <p
          className="bread-crumbs-link-container"
          style={{ fontWeight: "600" }}
        >
          <Link className="bread-crumbs-link" to="/">
            Home
          </Link>{" "}
          |{" "}
          <Link className="bread-crumbs-link" to="/label-group-management">
            Label Group Management
          </Link>
          -{" "}
          <b style={{ color: "gray" }}>
            {localStorage?.getItem("studyName")}
          </b>
        </p>
        <Grid2
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ width: "100%", margin: "0 auto" }}
        >
          <Grid2 item md={6}>
            <p className="page-heading">Label Group Management</p>
          </Grid2>
          <Grid2 item md={6}>
            <div className="search-bar-container">
              <SearchedComponent
                handleSearch={handleSearch}
                placeholder="Label Group"
                searchedValue={searchedValue}
              />
              {addLabelGroup && (
                <button
                  className="create-btn"
                  onClick={() => navigate("/addUpdate-label-group-management")}
                >
                  Add New Label Group
                </button>
              )}
            </div>
          </Grid2>
        </Grid2>

        {load ? (
          <Loader />
        ) : (
          <StyledGridComp
            rows={rowData}
            columns={columns}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            length={rowLength}
          ></StyledGridComp>
        )}

        <Grid2
          alignItems={"end"}
          justifyContent="end"
          container
          sx={{ marginTop: "2%" }}
        >
          <Grid2 item md={6}>
            <button className="create-btn">Back</button>
          </Grid2>
        </Grid2>
      </div>
    </>
  );
};

export default LabelGroupManagement;
